<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'UNIFIED_SEARCH.TITLE' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  <ion-spinner *ngIf="loading" name="bubbles" class="pageSpinner"></ion-spinner>
  <!--SearchBar-->
  <div>
    <div class="searchbar">
      <ion-searchbar
        #searchInput
        mode="ios"
        type="text"
        [placeholder]="'UNIFIED_SEARCH.PLACEHOLDER' | transloco"
        [(ngModel)]="searchTerm"
        (ionInput)="onSearchInput()"
        (keyup.enter)="onSearchInput()"
        (clear)="onSearchInput()"
        (ionClear)="clearSelection()"
        show-clear-button="always"
        style="width: 60%"></ion-searchbar>
      <ion-toggle [(ngModel)]="showInactive" (ionChange)="changeInactiveToggle($event)">{{
        'UNIFIED_SEARCH.SHOW_INACTIVE' | transloco
      }}</ion-toggle>
    </div>

    <!--Hint shown while the search term is below the minimum length-->
    <ion-note *ngIf="tooShort" class="ion-padding-start">
      {{ 'UNIFIED_SEARCH.MIN_LENGTH_HINT' | transloco: { count: minSearchLength } }}
    </ion-note>

    <!--Data grid-->
    <ion-list class="listContainer" *ngIf="!loading && !tooShort">
      <ion-item
        *ngFor="let result of results; trackBy: trackByFn"
        (click)="seeDetails(result)"
        [button]="true">
        <!--Icon depending on type-->
        <ion-icon
          slot="start"
          [ios]="getIconByType(result.type) + '-outline'"
          [md]="getIconByType(result.type) + '-sharp'"></ion-icon>
        <div style="width: 100%">
          <!--Text depending on type-->
          <div
            *ngIf="
              result.type === getSearchTypesEnum().EMPLOYEE || result.type === getSearchTypesEnum().SUPERVISOR
            "
            class="flexRow">
            <ion-label>
              {{ result.firstName + ' ' + result.lastName }}
            </ion-label>
            <ion-note> {{ result.email }}</ion-note>
            <ion-note> {{ result.phone }} </ion-note>
          </div>

          <div
            *ngIf="result.type === getSearchTypesEnum().SITE || result.type === getSearchTypesEnum().CLIENT"
            class="flexRow">
            <ion-label>
              {{ result.name }}
            </ion-label>
            <ion-note>{{ result.address }}</ion-note>
          </div>

          <div *ngIf="result.type === getSearchTypesEnum().COMMUNICATION" class="flexRow">
            <ion-label style="max-width: 50%">{{ result.message }}</ion-label>
            <ion-note>{{ result.employeeFullName }}</ion-note>
          </div>
          <!--Note of the type-->
          <ion-note> {{ getNoteByType(result.type) | transloco }}</ion-note>
        </div>
        <ion-icon color="medium" name="chevron-forward"></ion-icon>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
